import type { HelpFile } from '../../types/help'
import { SectionPropertiesTestIds } from '../../../testids/SectionPropertiesTestIds'

export const sectionPropertiesHelp: HelpFile = {
  docPage: '/docs/admin/form-layouts',
  texts: {
    [SectionPropertiesTestIds.sectionColumnsPropSelect]:
      'Anzahl der Spalten, in denen die Felder dieses Abschnitts angeordnet werden. Eine Spalte eignet sich für schmale Formulare, zwei für dichte, kompakte Layouts.',
  },
}
